<script setup lang="ts">
import CarouselScrollbar from '@shared/fondof-ui/components/molecules/carousel/CarouselScrollbar.vue'
</script>

<template>
  <CarouselScrollbar />
</template>

<style scoped>
:deep(.carousel__scrollbar) {
  --scrollbar-bg: theme('colors.gray.light.1');
  --scrollbar-height: theme('spacing.1');
  --thumb-bg: theme('colors.black');
  --thumb-width: theme('spacing.15');
  --thumb-transition: background theme('transitionDuration.200')
    theme('transitionTimingFunction.in-out');
}
</style>
